<template>
	<div class="work" id="work-7">
		<h2><span>08</span>Técnico Torcedor (Coach'n Fan)</h2>
		<div class="subtitle">
			<h3><span>Year</span>2015</h3>
			<h3><span>Product</span>App</h3>
			<h3><span>Technology</span>Phonegap</h3>
		</div>
		<blockquote>
			This app is for the soccer fans, being a fantasy game where you can set you team with and you can bet with friends in the matches results. 
		</blockquote>
		<figure>
			<figcaption>
				<h3>Project goal</h3>
				<p>Connect with this group of soccer fans in the matches, interacting in active way going beyond only supporting your team. The app wants to bring more than just supporting, making the users feel more thrill in the matches and playing to get more points in prizes.</p>
				<h3>My roles</h3>
				<p>Development of creating all the user flow to improve the experience before the match and in the  the progress of it. I was responsible for the user interface design of the app, visual design and research in all user behavior using it</p>
			</figcaption>
			<span><img src="../../assets/desk_tt_01.jpg" alt="Técnico Torcedor"></span>
		</figure>
		<figure class="half">
			<img style="box-shadow: none" src="../../assets/mob_tt.png" alt="App Técnico Torcedor">
			<figcaption>
				<h3>The problem</h3>
				<p>The app needed to work in an efficient way to have all the quality in smartphones in stadiums, bars, parks and places that the fans would probably gather to support their team. The initial conception was for one of the  main teams in Brazil, the tri-world champion São Paulo Futebol Clube  and was expanded in the championship of 2016 to all the main teams in Brazil. In 2018 we expanded for the Fifa World Cup. For that we needed to increase all data response, including the radio streaming in Brazil's National Team matches. 
The visual appealing was essential to maintain the engagement of the users even though the their team's performance was a huge influence on the app usage. </p>
			</figcaption>
		</figure>
		<figure class="half">
			<img src="../../assets/mob_tt_1.png" alt="App Técnico Torcedor">
			<img src="../../assets/mob_tt_2.png" alt="App Técnico Torcedor">
			<img src="../../assets/mob_tt_3.png" alt="App Técnico Torcedor">
		</figure>
		<figure>
			<figcaption>
				<h3>The solution</h3>
				<p>The soccer fans are really exigent and detail oriented regarding their teams. With that, it was crucial to incorporate on the app tech aspects all the the information for team formations, ways of kicking to goal, MVP, be aware of key moments like the play before the goal. So all the screens and interactions were done with a lot of attention to these small details.
To have all these requirements were made also connections with the traditionals soccer matches and the visual that these fans are used for the broadcasting of matches, so the user could focus on the game and be comfortable with the game on the app</p>
			</figcaption>
			<span><img src="../../assets/desk_tt_02.jpg" alt="Técnico Torcedor"></span>
		</figure>
		<blockquote>
			"It was my first app that came to life, many things learned that i'm brought for others apps produced, today i'm working on my fifth app and the Técnico Torcedor still the most difficult one, it's avaliable on playstore in the link <a href="//play.google.com/store/apps/details?id=br.com.tecnicotorcedor" target="_blank">Playstore</a>"
		</blockquote>
	</div>
</template>